import React, { PureComponent } from 'react';
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import 'moment/locale/pt-br';

const localizer = momentLocalizer(moment);

class CalendarComponent extends PureComponent {
  static propTypes = {
    events: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        allDay: PropTypes.bool,
        requestPresence: PropTypes.bool,
        start: PropTypes.instanceOf(Date),
        end: PropTypes.instanceOf(Date),
        description: PropTypes.string,
        location: PropTypes.string,
        calendar: PropTypes.shape(PropTypes.shape),
        alerts: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
        guest: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
      })
    ).isRequired,
    small: PropTypes.bool,
  };

  static defaultProps = {
    small: false,
  };

  eventStyleGetter = (event) => {
    const { color } = event.calendar;
    const style = {
      backgroundColor: color,
      border: 'none',
    };
    return {
      style,
    };
  };

  render() {
    const { small, events, selectEvent, t, onRangeChange } = this.props;
    return (
      <div className={`calendar${small ? ' calendar--small' : ''}`}>
        <BigCalendar
          selectable
          localizer={localizer}
          events={events}
          onSelectEvent={selectEvent}
          views={['month', 'week', 'day']}
          popup
          length={1}
          step={60}
          timeslots={1}
          showMultiDayTimes
          defaultDate={new Date()}
          eventPropGetter={this.eventStyleGetter}
          onSelectSlot={selectEvent}
          onRangeChange={onRangeChange}
          messages={{
            previous: <span className="lnr lnr-chevron-left" />,
            next: <span className="lnr lnr-chevron-right" />,
            today: <span className="lnr lnr-calendar-full" />,
            week: t('screens.calendar.week'),
            month: t('screens.calendar.month'),
            day: t('screens.calendar.day'),
            showMore: (total) => `+ ${total} Mais`,
          }}
        />
      </div>
    );
  }
}

CalendarComponent.propTypes = {
  selectEvent: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  onRangeChange: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(CalendarComponent)
);
